import { FileUploadResponse } from "../../Model/Response/ClientUser/FileUploadResponse";
import { ApiBaseResponse } from "../../Model/Response/Common/ApiBaseResponse";
import { GlobalOperations } from "../Common/GlobalOperations";

export async function UploadClientUserFile(file: File, hID: number, guid: string, sessionID: number): Promise<ApiBaseResponse<FileUploadResponse> | null> {

    if (GlobalOperations.UserToken === null)
        return null;
   
    const formData = new FormData();
    formData.append('file', file); // Dosyayı formData'ya ekliyoruz
    formData.append('hID', hID.toString());   // hID değerini formData'ya ekliyoruz
    formData.append('guid', guid); // guid değerini formData'ya ekliyoruz
    formData.append('sessionID', sessionID.toString()); // sessionID değerini formData'ya ekliyoruz
    
    // Dinamik olarak URL'yi oluşturma
    const uploadUrl = `${GlobalOperations.BaseUrl}api/ChatClientSide/UploadClientUserFile`;

    

    // POST işlemi için fetch kullanımı
    let response = await fetch(uploadUrl, {
        method: 'POST',
        headers: {
            'Authorization': GlobalOperations.UserToken 
        },
        body: formData // formData nesnesini gönderiyoruz
    });

    // Sunucudan gelen cevabı işliyoruz
    if (response.ok) {
        let data: ApiBaseResponse<FileUploadResponse> = await response.json();
        return data;
    } else {
        // Hata durumunu ele almak için
        let errorText = await response.text();
        console.error("Dosya yükleme hatası:", errorText);
        return null;
    }
}
